import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TemplateEPLList from './template-epl-list';
import * as ProjectActionType from 'Projects/constants';

import './template.css';

class TemplateEPL extends Component {

    static propTypes = {
      projectId: PropTypes.string,
      dispatch: PropTypes.func,
      DefaultTemplateList: PropTypes.array,
      isOpen: PropTypes.bool,
      getDefaultTemplate: PropTypes.func,
      customTemplateList2: PropTypes.object,
      BuilderName: PropTypes.string,
      ProjectListCopy: PropTypes.array
    }

    constructor(props) {
      super(props);
      this.state = {
        isOpen: false,
        checked: false,
        openAddCustomTemplate: true,
        items: [],
        builderName: this.props.BuilderName
      };
    }

    componentDidMount() {
      this.getDefaultTemplate();
      this.onGetBuilderName();
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.BuilderName !== nextProps.BuilderName) {
        this.setState({ builderName: nextProps.BuilderName});
      }
    }

    getDefaultTemplate() {
      this.props.getDefaultTemplate();
    }

    onCloseCustomTempSectionModal = () => {
      this.setState({
        isOpen: false
      });
    }

    onGetBuilderName = () => {
      this.props.dispatch({
        type: ProjectActionType.GET_BUILDER_NAME_ASYNC,
        params: null
      });
    }

    selectCustomTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.SELECT_CUSTOM_TEMPLATE_ASYNC,
        params: {
          projectId: params.projectId,
          templateId: params.templateId
        }, callback
      });
    }

    selectDefaultTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.SELECT_CUSTOM_TEMPLATE_ASYNC,
        params: {
          projectId: params.projectId,
          templateId: params.templateId
        },
        callback
      });
    }

    onCreateCustomTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.CREATE_NEW_PROJECT_EOC_TEMPLATE_ASYNC,
        params: {
          projectId: this.props.projectId,
          data: params.data
        },
        callback
      });
    }

    onEditEPLTemplate = (params, callback) => {
      let submittedSections = params.data.sections.map(section => {
        return {
          name: section.name,
          items: section.items.filter(item => item.name !== null && item.name.length > 0).map(item => item.name)
        };
      });

      const data = {
        id: params.data.id,
        name: params.data.name,
        disclaimer: params.data.disclaimer,
        sections: submittedSections,
        IsCheckedTitle1: params.data.IsCheckedTitle1 || false,
        IsCheckedTitle2: params.data.IsCheckedTitle2 || false,
        IsCheckedTitle3: params.data.IsCheckedTitle3 || false
      };

      if (params.data.Title1) {
        data.Title1 = params.data.Title1;
      }
      if (params.data.Title2) {
        data.Title2 = params.data.Title2;
      }
      if (params.data.Title3) {
        data.Title3 = params.data.Title3;
      }

      this.props.dispatch({
        type: ProjectActionType.EDIT_EPL_TEMPLATE_ASYNC,
        params: { data },
        callback
      });
    }

    getCustomTemplateDetail = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.GET_CUSTOM_TEMPLATE_DETAIL_ASYNC,
        params: {
          projectId: params.projectId,
          templateId: params.templateId
        },
        callback
      });
    }

    getCustomTemplateDetail2 = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.GET_CUSTOM_TEMPLATE_DETAIL2_ASYNC,
        params: {
          templateId: params.templateId
        },
        callback
      });
    }

    onDuplicateEOCTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.DUPLICATE_EOC_TEMPLATE_ASYNC,
        params: {
          projectId: params.projectId,
          templateId: params.templateId
        },
        callback
      });
    }

    onCopyEOFTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.COPY_EOF_TEMPLATE_ASYNC,
        params: {
          targetProjectId: params.targetProjectId,
          templateId: params.templateId
        },
        callback
      });
    }

    onFetchProject = (params) => {
      this.props.dispatch({
        type: ProjectActionType.GET_LIST_COPY_EOC_TEMPLATE_LIST_ASYNC,
        params: {
          excludeProjectId: params.projectId
        }
      });
    };

    render() {
      return (
        <React.Fragment>
          <div className=' margin-bottom-30 container-fluid'>
            <TemplateEPLList
              onEditCustomTemplate={this.onEditEPLTemplate}
              customTemplateList={this.props.customTemplateList2}
              getCustomTemplateDetail={this.getCustomTemplateDetail2}
              selectCustomTemplate= {this.selectCustomTemplate}
              selectDefaultTemplate={this.selectDefaultTemplate}
              projectId={this.props.projectId}
              DefaultTemplateList={this.props.DefaultTemplateList}
              getDefaultTemplate={this.props.getDefaultTemplate}
              onDuplicateEOCTemplate={this.onDuplicateEOCTemplate}
              onCopyEOFTemplate={this.onCopyEOFTemplate}
              onFetchProject={this.onFetchProject}
              ProjectListCopy={this.props.ProjectListCopy}
            />
          </div>
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    ProjectStore: state.ProjectStore,
    BuilderName: state.ProjectStore.BuilderName,
    customTemplateList2: state.ProjectStore.customTemplateList2,
    ProjectListCopy: state.ProjectStore.ProjectListCopy
  };
};

export default connect(mapStateToProps)(TemplateEPL);




// WEBPACK FOOTER //
// ./src/Projects/Components/Template/template-epl.js